import React from "react";
import StepHeader from "../common/StepHeader";
import PrimaryButton from "../common/PrimaryButton";
import { Button, IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import Swal from "sweetalert2";

import "./ImageEditor.css";
import QuickPrompts from "./QuickPrompts";

const ImageEditor = ({
    image,
    editMessage,
    setEditMessage,
    onSend,
    loading,
    chatInputRef,
    editImagePreview,
    onImageChange,
    onRemoveImage
}) => {

    return (
        <div className="editor-card">
            {/* <StepHeader
                title="AI Image Editor"
                subtitle="Refine your image through prompt"
            /> */}

            <div className="editor-form-wrapper" style={{ display: "flex", flexDirection: "column", flex: 1, marginTop: "20px" }}>

                <div className="prompt-input-wrapper">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                        <label style={{ color: "white", fontWeight: "600", marginBottom: 0 }}>
                            Edit Generated Image:
                            <span>*</span>
                        </label>
                        {editMessage && (
                            <Button
                                onClick={() => setEditMessage("")}
                                title="Clear text"
                                variant="outlined"
                                color="error"
                                size="small"

                            >
                                Clear
                            </Button>
                        )}
                    </div>
                    <textarea
                        ref={chatInputRef}
                        value={editMessage}
                        onChange={(e) => setEditMessage(e.target.value)}
                        placeholder="Tell AI what to change..."
                        style={{ minHeight: "150px" }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                onSend();
                            }
                        }}
                    />
                </div>

                <div style={{ marginTop: "15px" }}>
                    <QuickPrompts editMessage={editMessage} setEditMessage={setEditMessage} />
                </div>

                {!loading && image && <p style={{ marginTop: "10px", fontSize: "12px", color: "gray" }}>You can upload an image and provide instructions on how to use it. It can be added as a logo, incorporated into the generated image, or used as a reference for the AI to create your design.</p>}

                <div style={{ marginTop: "8px" }}>
                    {!loading && image && (
                        <div className="generated-upload-sidebar" style={{ flexDirection: 'row', width: 'auto', gap: '15px', marginBottom: '15px' }}>
                            <button
                                className="upload-plus-btn"
                                onClick={() => document.getElementById("edit-image-upload").click()}
                                title="Select an image"
                                style={{ width: '50px', height: '50px', fontSize: '24px', borderRadius: '8px' }}
                            >
                                +
                            </button>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                {editImagePreview && (
                                    <div className="upload-preview-container" style={{ marginTop: '5px', width: '40px' }}>
                                        <img src={editImagePreview} alt="Preview" className="upload-preview-img" />
                                        <button className="upload-preview-remove" onClick={onRemoveImage} style={{ width: '16px', height: '16px', fontSize: '10px', top: '-5px', right: '-5px' }}>✕</button>
                                    </div>
                                )}
                            </div>
                            <input
                                id="edit-image-upload"
                                type="file"
                                accept="image/*"
                                onChange={onImageChange}
                                style={{ display: "none" }}
                            />
                        </div>
                    )}
                    {!loading && image && <p className="upload-supported-text" style={{ textAlign: 'left' }}>Supported types: JPG, PNG, WEBP</p>}

                    <div className="prompt-buttons">
                        <PrimaryButton
                            onClick={onSend}
                            disabled={!editMessage.trim() || loading || !image}
                            style={{ width: "100%" }}
                        >
                            {loading ? "Editing..." : "Apply Edit"}
                        </PrimaryButton>
                    </div>

                    <p className="credit-text">Each edit uses 10 credits</p>
                </div>
            </div>
        </div>
    );
};

export default ImageEditor;